<template>
  <article class="pt-100 px-100 pb-300">
    <LcCard body-class="flex flex-col gap-200" radius="medium" shadow="large" tabindex="0">
      <PickLotteryPlaySlipNumbersSelection ref="numbersSelection" v-bind="{ play }" />
      <PickLotteryPlaySlipStakeSelection v-bind="{ play }" />
    </LcCard>
  </article>
</template>

<script setup lang="ts">
import PickLotteryPlaySlipNumbersSelection from './PickLotteryPlaySlipNumbersSelection.vue'

type PickLotteryBasePlaySlipItemEmits = {
  (e: 'play-state-changed', isDirty: boolean, playId: string): void
}

type PickLotteryBasePlaySlipItemProps = {
  disabled?: boolean
  play: PlaySlipPlay
}

const { disabled, play } = defineProps<PickLotteryBasePlaySlipItemProps>()

const emit = defineEmits<PickLotteryBasePlaySlipItemEmits>()

const numbersSelectionRef = useTemplateRef('numbersSelection')

const areAllFieldsSet = computed(
  () =>
    play.fields.every((field) => field.selected.length > 0) &&
    !!play.perPlayAddOn &&
    play.perPlayAddOn.value !== '',
)
const isPlayComplete = computed(() => play.isComplete)

watch(isPlayComplete, () => {
  emit('play-state-changed', isPlayComplete.value, play.id)
})

watchImmediate(
  () => disabled,
  async () => {
    if (disabled || !areAllFieldsSet.value) return
    await nextTick()
    numbersSelectionRef.value?.validate()
  },
)
</script>
